
import * as yaml from 'js-yaml'

function message_clear() {
  message_out.innerHTML = ""
}

function message(line) {
  console.log(line)
  message_out.innerHTML += `<pre>${line}</pre>`
}

function github_file(url) {
  url = url.replace("github.com", "raw.githubusercontent.com")
  url = url.replace("/blob/", "/")
  return url
}

async function load_yaml_url(url) {
  const res = await fetch( url )
  //console.log(res.ok)
  if(!res.ok) {
    throw Error(`error loading ${url}`)
  }
  const txt = await res.text()
  //console.log(txt)

  return yaml.load(txt)
}

function xz(pt) {
  if(pt.length == 3) {
    return [pt[0], pt[2]]
  }
  return pt
}

function to_loc(line) {
  let loc = line.replace("Warp::", "")
  if(loc in META) {
    if('coord' in META[loc]) {
      let pt = META[loc]['coord']
      return xz(pt)
    }
  }
  return undefined
}

function process_segment(segment) {
  let pts = []
  for(const part of segment) {
    console.log(part)
    if(typeof part == "string") {
      let pt = to_loc(part)
      if(pt) {
        pts.push(pt)
      }
      continue
    }
    let vals = Object.values(part)[0]
    let key = Object.keys(part)[0]
    if(key == "SOR") {
      continue
    }
    if(vals['coord']) {
      pts.push(xz(vals['coord']))
      continue
    }
    let pt = to_loc(key)
    if(pt) {
      pts.push(pt)
    }
  }
  return trim(pts)
}

function dist(a,b) {
  let dx = a[0] - b[0]
  let dz = a[1] - b[1]
  return Math.sqrt(dx*dx+dz*dz)
}
function trim(pts) {
  if(pts.length == 0) {
    return pts
  }
  let out = [pts[0]]
  for(let i = 1; i < pts.length; i++) {
    let d = dist(pts[i], pts[i-1])
    if(d > 1) {
      out.push(pts[i])
    }
  }
  return out
}

function HSVtoRGB(h, s, v) {
  var r, g, b, i, f, p, q, t;
  if (arguments.length === 1) {
    s = h.s, v = h.v, h = h.h;
  }
  i = Math.floor(h * 6);
  f = h * 6 - i;
  p = v * (1 - s);
  q = v * (1 - f * s);
  t = v * (1 - (1 - f) * s);
  switch (i % 6) {
    case 0: r = v, g = t, b = p; break;
    case 1: r = q, g = v, b = p; break;
    case 2: r = p, g = v, b = t; break;
    case 3: r = p, g = q, b = v; break;
    case 4: r = t, g = p, b = v; break;
    case 5: r = v, g = p, b = q; break;
  }
  let c = [
    Math.round(r * 255),
    Math.round(g * 255),
    Math.round(b * 255)
  ]
  return '#' + c.map(v => v.toString(16).padStart(2, '0')).join("")
}

function has_use(segment) {
  // Should have only 1 key and 1 value, typically an array 
  return Object.values(segment)[0].map(val => val.use).filter(x => x)
}

async function process_route(route, base_url) {
  let features = []
  let nsegments = route.length
  for(let segment of route) {
    if(typeof segment == "string") {
      console.log(segment)
      continue
    }
    let branch_name = Object.keys(segment)[0]
    let use = has_use(segment)
    //console.log(use)
    if(use.length == 1) {
      let use_url = use[0]
      console.log("use", use_url)
      let segment_url = [base_url, "main", use_url].join("/")
      segment = await load_yaml_url( github_file(segment_url) )
    } else if (use.length > 1) {
      throw new Error("multiple use in segment :/")
    } else {
      segment = Object.values(segment)[0]
    }
    //console.log(segment)
    let pts = process_segment(segment)

    let color = HSVtoRGB(features.length / nsegments, 1, 1)
    message(`branch: ${branch_name.padEnd(30,' ')} pts: ${pts.length.toFixed(0).padStart(5,' ')} color: ${color}`)

    let feat = {
      type: "Feature",
      properties: {
        title: branch_name,
        text: branch_name,
        pathLength: 0,
        order: features.length,
      },
      geometry: {
        type: "LineString",
        coordinates: pts
      },
      style: {
        color: color
      }
    }
    features.push(feat)
  }
  console.log("process route done", features.length)
  return features
}

let META = {}

async function load_json(filename) {
  const res = await fetch(filename)
  return res.json()
}

function download(data, filename, filetype) {
    const blob = new Blob([data], { type: filetype })
    const a = document.createElement('a')
    a.href = URL.createObjectURL(blob)
    a.download = filename
    a.click()
}


async function celer_to_objmap() {
  if(Object.keys(META).length == 0) {
    META = await load_json("celer_metadata.json")
  }

  const base_url = url_input.value
  //console.log(base_url)
  let project_url = base_url + "/main/project.yaml"
  //console.log(project_url)
  const base = await load_yaml_url( github_file(project_url) )
  //console.log(base)
  if(!base.route) {
    throw new Error("missing route in project.yaml")
  }
  let route = base.route;
  if(!route.use) {
    throw new Error(`missing use in project.yaml 'route'`)
  }
  let route_url = [base_url, "main", route.use].join("/")
  route = await load_yaml_url( github_file(route_url) )
  let features = await process_route(route, base_url)
  return {
    OBJMAP_SV_VERSION: 3,
    drawData: {
        type: "FeatureCollection",
        features: features
    },
    searchGroups: [],
    searchExcludeSets: []
  }
}

convert.addEventListener('click', async (ev) => {
  message_clear()
  let objmap_save = await celer_to_objmap()
  download(JSON.stringify(objmap_save,null,2), "objmap_save.json", "application/json")
})
